import config from '~/config';
import { isMeridianDealer } from '~/lib/utils';
import { accountDetailsSelector } from '~/state/selectors';
import { useAppSelector } from './useAppSelector';

export const useAIStrategyEnabled = () => {
    const accountDetails = useAppSelector(accountDetailsSelector);

    return (
        config.AI_STRATEGY === 'true' &&
        accountDetails?.strategyEnabled === true &&
        isMeridianDealer(accountDetails?.dealer)
    );
};
